import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Landing from './components/phoneVerify/Landing';
import AlreadyVerifiedView from './components/phoneVerify/AlreadyVerified';
import LockedOutView from './components/phoneVerify/TooManyTries';
import useLoginPage from './hooks/useLoginPage';
import VerifyCode from './components/phoneVerify/verifyCode/VerifyCode';
import { useMobileVerifyContext } from './context/MobileVerifyContext';
import { useLoginTracking } from '../../../hooks/useLoginTracking/useLoginTracking';
import { useTrackingContext } from '@jbhi-fi/components/src/Tracking';
import { HandleMobilePrompt } from '../perks/components/addMobileAndBirthday/HandleMobilePrompt';
import { AddMobileAndBirthday } from '../perks/components/addMobileAndBirthday/AddMobileAndBirthday';

const LoginPage = () => {
  const { onVerifyMobileResponse } = useLoginPage();
  const {
    data: { loading },
  } = useMobileVerifyContext();
  const { tracker } = useTrackingContext();
  useLoginTracking({ baseEventData: { eventCategory: tracker.category } });
  const query = new URLSearchParams(window.location.search);

  if (loading) return <Landing handleRedirect={onVerifyMobileResponse} />;

  return (
    <Switch>
      <Route exact path="/" render={() => <Landing handleRedirect={onVerifyMobileResponse} />} />
      <Route
        exact
        path="/link-your-in-store-receipts"
        render={() => <HandleMobilePrompt onVerifyMobileResponse={onVerifyMobileResponse} />}
      />
      <Route
        exact
        path="/add-birthday"
        render={() => (
          <AddMobileAndBirthday
            heading="Add your birthday month"
            content={
              query.get('source') === 'DRExist'
                ? 'Keep an eye out when it’s your birthday for a special Birthday Perk from us.'
                : 'We just need your birthday month to swing a gift your way.'
            }
            showLogo={true}
            handleRedirect={onVerifyMobileResponse}
          />
        )}
      />
      <Route
        exact
        path="/mobile-number-already-verified"
        render={() => <AlreadyVerifiedView handleRedirect={onVerifyMobileResponse} />}
      />
      <Route exact path="/oops-youve-tried-too-many-times" render={() => <LockedOutView />} />
      <Route
        exact
        path="/enter-verification-code"
        render={() => <VerifyCode handleRedirect={onVerifyMobileResponse} />}
      />
      <Route render={() => <Landing handleRedirect={onVerifyMobileResponse} />} />
    </Switch>
  );
};

export default LoginPage;
